if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
if(window['country_liquid']){
  function setCountryLink(data){
    var country_link_content = document.querySelector('.country_link_content_html');
    country_link_content.innerHTML = '';
    if(window['country_liquid']['none'] && window['country_liquid']['none'].length > 1){
      var data2 = window['country_liquid']['none'];
      setLinkHtml(data2, country_link_content);
    }else if(window['country_liquid']['variant']){
      if(window['country_liquid']['variant']['none'] && window['country_liquid']['variant']['none'].length > 1){
        var data2 = window['country_liquid']['variant']['none'];
        setLinkHtml(data2, country_link_content);
      }else{
        for(var key in window['country_liquid']['variant']){
          var arr = key.toLowerCase().split('@');
          var len1 = arr.length;
          var len2 = data.length;
          if(len1 == len2){
            for(var i = 0; i < len2; i++){
              if(arr.indexOf(data[i]) == -1){
                break
              }
            }
            if(len1 == i){
              var data2 = window['country_liquid']['variant'][key];
              setLinkHtml(data2, country_link_content);
              break
            }
          }
        }
      }
    }
  }
  function inputChang(){
    var data = [];
    document.querySelectorAll('variant-radios input:checked').forEach(function(el){
      data.push(el.value.toLowerCase())
    });
    setCountryLink(data);
  }
  inputChang();
  document.querySelectorAll('variant-radios input').forEach(function(el){
    el.addEventListener('change', function(){
      inputChang();
    });
  });
  function setLinkHtml(data, obj){
    var html = "";
    for(var i = 0; i < data.length; i++){
      var arr = data[i].split('@');
      var picName = country_image[arr[0]];
      if(picName){
        html += `<div><a href="${arr[1]}" target="_blank"><img src="${picName}"/></a></div>`;
      }
    }
    obj.innerHTML = html;
  }
}